import { Location } from 'planning-portal-library/src/lib/core/domain';
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base";
import { BulkUpdateLocationRequest } from "../../domain/requests/locations/bulk-update-location.request";
import { LocationsRepository } from "../../repositories";



@Injectable({ providedIn: 'root' })
export class BulkUpdateLocationUsecase implements UseCase<BulkUpdateLocationRequest, boolean> {

  constructor(private locationRepository: LocationsRepository) {
  }

  execute(params: BulkUpdateLocationRequest): Observable<boolean> {
    return this.locationRepository.bulkUpdateLocation(params);
  }

}
